export const MAP_API = '/data/map.json'
export const PROJECTS_API = '/data/projects.json'
export const BASE_IMAGE_URL = process.env.NODE_ENV === 'development' ? '' : 'https://angry-heyrovsky-acb192.netlify.app'